export
const name: string = "AccColor";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform SMaterial   u_material;
    uniform vec2        u_canvas_size_recip;
    uniform sampler2D   u_tex_opaque_depth;
    uniform highp sampler2D u_tex_acc_depth;
`;

export
const varyings: string = `
    #if defined(TEXTURED)
    varying vec2        v_tex_coord;
    #endif

    varying lowp float  v_selected;
`;

export
const implementation: string = `
    // https://www.gamedev.net/forums/topic/642119-oit-with-weighted-average/
    // http://jcgt.org/published/0002/02/09/
    // but do not have float target, so we have to divide the color via the depl complexity value
    void main()
    {
    #ifdef CLIPPING_PLANE
        // Cutting plane
        resolveClippingPlane();
    #endif

        // if we have more views in one canvas, and the glViewport restrict the drawing to only a selected part of the canvas
        // the gl_FragCoord.xy contains coodinates in pixes relative to the canvas and not relative the viewport
        vec2 normalizedTextureCoord = gl_FragCoord.xy * u_canvas_size_recip;

        highp vec4 depth = texture2D(u_tex_opaque_depth, normalizedTextureCoord);
        highp float depth_opaque = vec4ToFloat(depth);

        // HACK!!! assigning the gl_FragCoord.z value to z is needed for iPhone6 :-)
        float z = gl_FragCoord.z;
        if (z > depth_opaque) {
            // discard is performance hit so accumulate zero instead
            gl_FragColor = vec4(0.0);
        }
        else {

    #if defined(TEXTURED)
            // in chrome when chrome://gpu show that "Canvas: Software only, hardware acceleration unavailable"
            // then returning from function to struct members does not work
            SMaterial surfaceMat = applyTextureToSurface(u_material, v_tex_coord);
            if (v_selected > 0.5) {
                surfaceMat.ambient = u_selected_material_diffuse;
                surfaceMat.diffuse = clamp(surfaceMat.texColorReadOnly + vec3(0.4), 0.0, 1.0) * u_selected_material_diffuse;
                //surfaceMat.shading = 0;
            }
    #else
            SMaterial surfaceMat = u_material;
            if (v_selected > 0.5) {
                surfaceMat.ambient = SELECTED_MATERIAL_AMBIENT;
                surfaceMat.diffuse = u_selected_material_diffuse;
                //surfaceMat.shading = 0;
            }
    #endif
            highp float n = texture2D(u_tex_acc_depth, normalizedTextureCoord).r * 255.0;

            highp vec4 shadedColor = applyLighting(surfaceMat);
            
            /// this is normal wavg
            shadedColor = vec4(shadedColor.xyz * shadedColor.w / n, shadedColor.w / n);
            
            /// this is try to weight the alpha channel by distance form camera
            /// highp float w = clamp(0.3 / (1e-5 + pow(1.0 - z, 2.0)), 1e-2, 3e3);
            /// shadedColor = vec4(shadedColor.xyz * shadedColor.w / n, w * shadedColor.w / n);
            gl_FragColor = shadedColor;
        }
    }
`;
